import chroma from "chroma-js";
import { mergeDeep } from "../../../utils/commons";

const colors = {
  default(includeNullColor = false) {
    let colors = chroma.scale(["#a4dafa", "#220058"]).mode("lch").colors(6);

    if (includeNullColor) {
      colors = ["#acacac", ...colors];
    }
    return colors;
  },
  darken(color) {
    return chroma(color).darken();
  },
};
const plugins = {
  noData: {
    afterDraw: function (chart) {
      if (chart.data.datasets.length === 0) {
        // No data is present
        const ctx = chart.chart.ctx;
        const width = chart.chart.width;
        const height = chart.chart.height;

        ctx.save();
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.font = "16px normal 'Helvetica Nueue'";
        ctx.fillText("Sem dados disponíveis", width / 2, height / 2);
        ctx.restore();
      }
    },
  },
};

const opts = {
  chart: {
    animations: {
      speed: 500,
    },
  },
  title: {
    align: "center",
  },
  noData: {
    text: "Sem dados disponíveis",
  },
  legend: {
    show: true,
  },
  colors: [],
  labels: [],
};

const commonOptions = {
  apply(customOpts) {
    return mergeDeep({}, opts, customOpts);
  },
};
export { colors, commonOptions, plugins };
